export class Loader {
    constructor(el) {
        if (!el) return;
        this.root = el;

        this.activeClass = '-active';
    }

    show() {
        this.root?.classList.add(this.activeClass);
    }

    hide() {
        this.root?.classList.remove(this.activeClass);
    }
}
